/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientMedicineAlarmTimingTypename = "PatientMedicineAlarmTiming" as const;

/**
 *
 * @export
 * @interface PatientMedicineAlarmTiming
 */
export interface PatientMedicineAlarmTiming {
  /**
   *
   * @type {string}
   * @memberof PatientMedicineAlarmTiming
   */
  time: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientMedicineAlarmTiming
   */
  readonly __typename?: string;
}

export function PatientMedicineAlarmTimingFromJSON(json: any): PatientMedicineAlarmTiming {
  return PatientMedicineAlarmTimingFromJSONTyped(json, false);
}

export function PatientMedicineAlarmTimingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientMedicineAlarmTiming {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientMedicineAlarmTimingTypename,

    time: json["time"],
  };
}

export function PatientMedicineAlarmTimingToJSON(object?: PatientMedicineAlarmTiming | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    time: value.time,
  };
}
